<template>
  <feature-toggle :toggle="enableSkipOptimisation">
    <v-row no-gutters>
      <v-col cols="12">
        <div class="optimise-prices-wrapper">
          <v-switch
            :label="$t('workPackages.optimisePrices')"
            :input-value="createWorkpackageOptimisePrices"
            :disabled="forceDisabled"
            primary
            hide-details
            class="font-weight-regular"
            @change="toggleOptimisePrices"
          />
        </div>
      </v-col>
    </v-row>
  </feature-toggle>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { enableSkipOptimisation } from '@enums/feature-flags';

/**
 * SkipOptimisationToggle component
 *
 * This component displays a toggle switch allowing users to skip price optimisation after WP creation.
 * Intention price will be set as scenario price if the toggle is disabled, and the optimisation step will be skipped when running the engine.
 * By default optimisation is enabled. Regular recalculate all will run.
 *
 */
export default {
  props: {
    forceDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      enableSkipOptimisation,
    };
  },

  computed: {
    ...mapState('workpackages', ['createWorkpackageOptimisePrices']),
  },

  methods: {
    ...mapMutations('workpackages', ['setCreateWorkpackageOptimisePrices']),

    toggleOptimisePrices(value) {
      this.setCreateWorkpackageOptimisePrices(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.optimise-prices-wrapper {
  height: 45px;
  padding-top: 4px;
}
</style>
